import React from "react";
import "./About.css";

const BRANDS = [
  "Bandai",
  "Good Smile Company",
  "Kaiyodo",
  "Sega",
  "Bandai Hobby",
];

const VALUES = [
  {
    icon: "pi pi-star",
    title: "Figuras auténticas",
    desc: "Solo trabajamos con figuras originales importadas directamente de Japón. Sin réplicas, sin dudas.",
  },
  {
    icon: "pi pi-shield",
    title: "Compra segura",
    desc: "Embalaje cuidadoso y seguimiento en cada envío para que tu figura llegue en perfectas condiciones.",
  },
  {
    icon: "pi pi-comments",
    title: "Atención personalizada",
    desc: "Somos una tienda pequeña que conoce el coleccionismo por dentro. Tu consulta la atiende alguien que sabe.",
  },
  {
    icon: "pi pi-credit-card",
    title: "Apartados flexibles",
    desc: "Sabemos que las figuras pueden ser costosas. Por eso ofrecemos apartados con solo el 20% del valor.",
  },
];

export default function Acerca() {
  return (
    <div className="acerca-page">

      {/* ── Hero ── */}
      <header className="acerca-hero">
        <div className="acerca-hero__inner">
          <span className="acerca-hero__eyebrow">Angelvarius Shop</span>
          <h1 className="acerca-hero__title">Acerca de nosotros</h1>
          <p className="acerca-hero__sub">
            Una tienda especializada en figuras importadas de Japón, para coleccionistas
            que exigen lo mejor.
          </p>
        </div>
        <div className="acerca-hero__deco" aria-hidden="true">
          <span className="acerca-hero__deco-ring acerca-hero__deco-ring--1" />
          <span className="acerca-hero__deco-ring acerca-hero__deco-ring--2" />
          <span className="acerca-hero__deco-ring acerca-hero__deco-ring--3" />
        </div>
      </header>

      <main className="acerca-content">

        {/* ── Historia ── */}
        <section className="acerca-story">
          <div className="acerca-story__text">
            <span className="acerca-label">Nuestra historia</span>
            <h2 className="acerca-heading">Del coleccionismo a la tienda</h2>
            <p>
              Angelvarius Shop nació de la pasión por las figuras japonesas. Lo que comenzó
              como un hobby personal se convirtió en una comunidad de coleccionistas en
              Guadalajara que comparten el mismo amor por el anime, los videojuegos y el
              arte en miniatura.
            </p>
            <p>
              Hoy traemos directamente desde Japón las piezas más buscadas de las marcas
              más reconocidas del sector, con la misma dedicación y cuidado que pondríamos
              en nuestra propia colección.
            </p>
          </div>
          <div className="acerca-story__brands">
            <span className="acerca-label">Marcas que manejamos</span>
            <ul className="acerca-brands-list">
              {BRANDS.map((b) => (
                <li key={b} className="acerca-brands-item">
                  <i className="pi pi-check-circle" />
                  {b}
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* ── Divider ── */}
        <div className="acerca-divider" aria-hidden="true" />

        {/* ── Valores ── */}
        <section className="acerca-values-section">
          <div className="acerca-values-head">
            <span className="acerca-label">Por qué elegirnos</span>
            <h2 className="acerca-heading">Lo que nos define</h2>
          </div>
          <div className="acerca-values-grid">
            {VALUES.map((v) => (
              <div className="acerca-value-card" key={v.title}>
                <div className="acerca-value-card__icon">
                  <i className={v.icon} />
                </div>
                <h3 className="acerca-value-card__title">{v.title}</h3>
                <p className="acerca-value-card__desc">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── CTA ── */}
        <section className="acerca-cta">
          <div className="acerca-cta__inner">
            <h2 className="acerca-cta__title">¿Lista tu próxima figura?</h2>
            <p className="acerca-cta__sub">
              Explora el catálogo o escríbenos si buscas algo específico.
            </p>
            <div className="acerca-cta__btns">
              <a href="/shop" className="acerca-btn acerca-btn--primary">
                Ver catálogo <i className="pi pi-arrow-right" />
              </a>
              <a href="/contact" className="acerca-btn acerca-btn--outline">
                Contactarnos
              </a>
            </div>
          </div>
        </section>

      </main>
    </div>
  );
}
